import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Tyson's Cannabis · Informational Hub</p>
        <h1>Welcome to Tyson's Cannabis Information Center</h1>
        <p className="lede">
          Your go-to source for the latest updates on cannabis policy, culture, and legal status in Tyson's Corner. Stay informed with our comprehensive coverage and educational resources.
        </p>
        <div className="cta-row">
          <a href="/latest-news" target="_self">
            Read the Latest News
          </a>
          <a href="/educational-resources" target="_self" className="secondary">
            Explore Educational Resources
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Local Law Updates</h2>
          <p>
            Stay updated on the latest changes to cannabis legislation and regulations affecting Tyson's Corner. Our coverage provides insights into local policies and their implications for the community.
          </p>
        </article>
        <article>
          <h2>Cannabis Culture Insights</h2>
          <p>
            Discover the evolving culture surrounding cannabis in our area. From community events to educational initiatives, we highlight the diverse aspects of cannabis culture that shape our community.
          </p>
        </article>
        <article>
          <h2>Legal Status Information</h2>
          <p>
            Get informed about the legal status of cannabis in Tyson's Corner. Our guides offer clarity on what is permitted and what to be aware of regarding cannabis use and possession.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;